import { Component, Input, OnInit } from '@angular/core';
import { NavigationButtonState } from '../models/navigationButtonState';

@Component({
  selector: 'app-navigation-step',
  templateUrl: './navigation-step.component.html',
  styleUrls: ['./navigation-step.component.css']
})
export class NavigationStepComponent implements OnInit {
  @Input() redirectLinkName = '';
  @Input() name = '';
  @Input() index = '';
  @Input() navState: NavigationButtonState = 'inactive';
  styleClass = '';

  constructor() {

    
  }

  ngOnInit(): void {
    switch (this.navState) {
      case 'active':
        this.styleClass = 'w-full p-4 text-red-700 bg-red-50 border border-red-300 rounded-lg dark:bg-gray-800 dark:border-red-800 dark:text-red-400';
        break;
      case 'inactive':
        this.styleClass = 'w-full p-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400';
        break;
      case 'complete':
        this.styleClass = 'w-full p-4 text-white border border-black rounded-lg bg-black dark:bg-gray-800 dark:border-black dark:text-white';
        break;
      default:
        this.styleClass = 'w-full p-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400';
    }
  }

}
